import { render, staticRenderFns } from "./declaracionJurada.vue?vue&type=template&id=0e6e5d1a&"
import script from "./declaracionJurada.vue?vue&type=script&lang=ts&"
export * from "./declaracionJurada.vue?vue&type=script&lang=ts&"
import style0 from "./declaracionJurada.vue?vue&type=style&index=0&id=0e6e5d1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports